export const getTimesheetsRoute = '/timesheets';
export const getStaffTimesheetsRoute = '/staff-timesheets';
